import React from "react";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import MetaComponent from "@/components/common/MetaComponent";
import ResetPassword from "@/components/password-reset/ResetPassword";

const metadata = {
  title: "Hubzu | Update Password",
};

const ResetPasswordScreen = () => {
  return (
    <div>
      <Header />
      <MobileMenu />
      <MetaComponent meta={metadata} />
      <ResetPassword />
    </div>
  );
};

export default ResetPasswordScreen;
